<template>
  <div class="telephone-component">
    <div class="col-md-6 col-sm-12 col-xs-12 d-flex flex-column justify-content-center p-3">
      <div class="text-center text-red" v-show="audioOutput === null || audioInput === null">Chưa chọn thiết bị đầu vào, đầu ra</div>
      <div class="d-flex flex-row justify-content-center">
        <div class="hidden">
          <h1>{{ this.ua === null ? '' : this.ua.userAgent._state }}</h1>
          <h1>{{this.incomingCallNumber? this.incomingCallNumber.uri.raw.user : ''}}</h1>
        </div>
        <Keypad v-show="callType === null" :call="call" :audioInput="audioInput" :audioOutput="audioOutput"></Keypad>
        <CallOut v-show="callType === type.CALL_OUT" :cancel="hangup"></CallOut>
        <CallIn v-show="callType === type.CALL_IN" :cancel="hangup"></CallIn>
      </div>
    </div>
    <div class="col-md-6 col-sm-12 col-xs-12">
      <HistoryList ref="historyList" :recall="recall"></HistoryList>
    </div>
  </div>
</template>

<script>
import Keypad from './Keypad'
import HistoryList from './HistoryList'
import CallOut from './CallOut'
import CallIn from './CallIn'
import ity from '../../lib/ity'
import {mapActions, mapGetters} from 'vuex'
import Util from '../../common/utils'
import {CALL_STATE, CALL_TYPE} from '../../common/constant'
import callCenterAPI from '../../api/callCenter'
import sound from '../../assets/hangup.mp3'

export default {
  name: 'SoftPhone',
  props: {
    audioInput: {
      type: String
    },
    audioOutput: {
      type: String
    },
  },
  components: {
    Keypad,
    HistoryList,
    CallOut,
    CallIn
  },
  computed: {
    ...mapGetters([
      'softphone'
    ]),
    ua () {
      return ity.ua
    },
    incomingCallNumber () {
      if (!ity.ua.session) return null
      return ity.ua.session.remoteIdentity
    },
    callState () {
      return ity.callState
    },
    callType () {
      return ity.callType
    },
    isReceivingCall () {
      return ity.isReceivingCall
    }
  },
  data () {
    return {
      state: CALL_STATE,
      type: CALL_TYPE,
    }
  },
  mounted () {
    const phoneNumber = Util.formatPhoneNumber(this.softphone.phoneNumber)
    if (phoneNumber !== '' && ity.callType !== CALL_TYPE.CALL_IN) {
      this.call()
    }
  },
  methods: {
    ...mapActions([
      'changePhoneNumber'
    ]),
    disconnect () {
      this.ua.disconnect()
    },
    call () {
      callCenterAPI.start_callout().then(res => {
        const phoneNumber = Util.formatPhoneNumber(this.softphone.phoneNumber)
        if (phoneNumber === '') {
          return
        }
        ity.callType = CALL_TYPE.CALL_OUT
        ity.callState = CALL_STATE.CREATED
        this.ua.call(phoneNumber)
      }).catch((err) => {
        Util.handleError(this.$bvToast, err)
        ity.callType = null
      })
    },
    hangup () {
      try {
        this.ua.hangup()
        let audio = document.getElementById('remoteAudio')
        audio.srcObject = sound
        audio.play()
      } catch (e) {
        console.log('Error: ', e)
      }

      if (this.$ref) {
        setTimeout(() => {
          this.$refs.historyList.reload()
        }, 2000)
      }
    },
    recall (number) {
      callCenterAPI.start_callout().then(res => {
        ity.callType = CALL_TYPE.CALL_OUT
        ity.callState = CALL_STATE.CREATED
        const phoneNumber = Util.formatPhoneNumber(number)
        this.changePhoneNumber({phoneNumber: phoneNumber})
        this.ua.call(phoneNumber)
      }).catch((err) => {
        Util.handleError(this.$bvToast, err)
        ity.callType = null
      })
    }
  },
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/telephone/SoftPhone.vue